var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-warp"},_vm._l((_vm.items),function(i,k){return _c('div',{key:k,staticClass:"item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(i.name))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(i.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }